import { render, staticRenderFns } from "./CombinedLogo.vue?vue&type=template&id=9b5225a6&"
import script from "./CombinedLogo.vue?vue&type=script&lang=js&"
export * from "./CombinedLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports